import palette from './palette';

const slider = {
  MuiSlider: {
    styleOverrides: {
      root: {
        height: 10,
        width: 'calc(100% - 14px)',
        marginInline: '7px',
      },
      rail: {
        backgroundColor: palette.grey[200],
        opacity: 1,
      },
      track: {
        backgroundColor: palette.primary.main,
        border: 0,
      },
      thumb: {
        backgroundColor: 'transparent',
        borderColor: `${palette.common.black} transparent transparent transparent`,
        borderStyle: 'solid',
        borderWidth: '7px 7px 0 7px',
        borderRadius: 0,
        width: 0,
        height: 0,
        marginTop: -10,
        '&:hover, &.Mui-focusVisible, &.Mui-active': {
          boxShadow: 'none',
        },
        '&::before, &::after': {
          display: 'none',
        },
      },
    },
  },
};

export default slider;
